/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _helpersConnectData = require('helpers/connectData');

var _helpersConnectData2 = _interopRequireDefault(_helpersConnectData);

var _reactRedux = require('react-redux');

var _reduxModulesSearch = require('redux/modules/search');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactPagify = require('react-pagify');

var _reactPagify2 = _interopRequireDefault(_reactPagify);

var _segmentize = require('segmentize');

var _segmentize2 = _interopRequireDefault(_segmentize);

var _components = require('components');

/* eslint id-length: 0 */

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function fetchDataDeferred(getState, dispatch) {
	var promises = [];
	var state = getState();

	if (!_reduxModulesSearch.isLoaded(getState())) {
		promises.push(dispatch(_reduxModulesSearch.load(state.router.params.query, 20, 0)));
	}

	return _Promise.all(promises);
}

var Search = (function (_Component) {
	_inherits(Search, _Component);

	function Search() {
		var _this = this;

		_classCallCheck(this, _Search);

		_Component.apply(this, arguments);

		this.state = {
			currentPage: 1,
			pageOffset: 0,
			perPage: 20,
			showSidebar: false,
			isSmallViewport: false,
			isMediumViewport: false,
			isLargeViewport: false,
			mostPopularIsStuck: false,
			mostPopularIsStuckToBottom: false
		};

		this.handleSearch = function (page) {
			var dispatch = _this.context.store.dispatch;
			var query = _this.props.routeParams.query;
			var _state = _this.state;
			var pageOffset = _state.pageOffset;
			var perPage = _state.perPage;

			dispatch(_reduxModulesSearch.load(query, perPage, pageOffset + (page - 1)));
		};
	}

	Search.prototype.render = function render() {
		var _this2 = this;

		var styles = require('./Search.css');

		// Show loading spinner while article is fetched
		if (this.props.loading || this.props.loading === undefined) {
			return _react2['default'].createElement(
				'main',
				{ className: styles.Base },
				_react2['default'].createElement(_reactLoader2['default'], {
					className: 'spinner',
					color: 'rgb(255, 78, 61)',
					corners: 0,
					direction: 1,
					hwaccel: true,
					left: '50%',
					length: 6,
					lines: 13,
					opacity: 0.1,
					radius: 7,
					rotate: 13,
					scale: 1.00,
					shadow: false,
					speed: 2,
					top: '50%',
					trail: 60,
					width: 2,
					zIndex: 2e9 })
			);
		}

		var _props = this.props;
		var params = _props.params;
		var results = _props.results;

		var articles = _lodash2['default'].map(results.results, function (article) {
			var _classNames;

			var headerClasses = _classnames2['default']((_classNames = {}, _classNames[styles.ArticleHeader] = true, _classNames[styles['ArticleHeader--withImage']] = article.images && article.images['bbrew-small'], _classNames));

			return _react2['default'].createElement(
				'div',
				{ key: article.id },
				_react2['default'].createElement(
					'article',
					{ className: styles.Article },
					article.images && article.images['bbrew-small'] && _react2['default'].createElement(
						'figure',
						{ className: styles.ArticleFigure },
						_react2['default'].createElement(
							_reactRouter.Link,
							{ to: article.url },
							_react2['default'].createElement('img', { src: '' + _srcSettings2['default'].cdn + article.images['bbrew-small'][0] })
						)
					),
					_react2['default'].createElement(
						'header',
						{ className: headerClasses },
						_react2['default'].createElement(_components.MetaBar, {
							author: article.author.name,
							authorURI: article.author.slug,
							categories: article.categories,
							postDate: article.date }),
						_react2['default'].createElement(
							_reactRouter.Link,
							{ to: article.url, className: styles.Link },
							_react2['default'].createElement(
								'h1',
								{ className: styles.ArticleTitle },
								article.title
							),
							_this2.state.isSmallViewport && _react2['default'].createElement(
								'figure',
								{ className: styles.ArticleFigure },
								_react2['default'].createElement('img', { className: styles.FigureImage, src: '' + _srcSettings2['default'].cdn + article.images['bbrew-small'][0] })
							)
						)
					)
				)
			);
		});

		return _react2['default'].createElement(
			'main',
			{ className: styles.Base },
			_react2['default'].createElement(_reactHelmet2['default'], { title: 'Search Results for “' + params.query + '” | Baltimore Brew' }),
			_react2['default'].createElement(
				'section',
				{ className: styles.Results },
				_react2['default'].createElement(
					'header',
					{ className: styles.SectionHeader },
					_react2['default'].createElement(
						'h1',
						{ className: styles.Title },
						'Results'
					)
				),
				_react2['default'].createElement(
					'fieldset',
					{ className: styles.Search },
					_react2['default'].createElement(_components.SearchField, { value: params.query })
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.Articles },
					_react2['default'].createElement(
						'h4',
						{ className: styles.ResultCount },
						results.totalResults.toLocaleString('en'),
						' Results',
						results.totalPages > 1 && ' • Page ' + results.page
					),
					articles
				),
				results.totalPages > 1 && _react2['default'].createElement(
					'footer',
					{ className: styles.SectionFooter },
					_react2['default'].createElement(
						_reactPagify2['default'].Context,
						{ className: styles.Pagination,
							tags: {
								container: {
									tag: 'ul'
								},
								segment: {
									tag: 'li',
									props: {
										className: styles.PaginationLinks
									}
								},
								ellipsis: {
									tag: 'li'
								}
							},
							segments: _segmentize2['default']({
								beginPages: 1,
								endPages: 1,
								page: results.page,
								pages: results.totalPages,
								sidePages: 2
							}), onSelect: function (page) {
								return _this2.handleSearch(page);
							} },
						_react2['default'].createElement(
							_reactPagify2['default'].Button,
							{ className: styles['PaginationLinks--previous'], page: results.page - 1 },
							'«'
						),
						_react2['default'].createElement(_reactPagify2['default'].Segment, { field: 'beginPages' }),
						_react2['default'].createElement(_reactPagify2['default'].Ellipsis, { className: styles.PaginationEllipsis, previousField: 'beginPages', nextField: 'previousPages' }),
						_react2['default'].createElement(_reactPagify2['default'].Segment, { field: 'previousPages' }),
						_react2['default'].createElement(_reactPagify2['default'].Segment, { field: 'centerPage', className: styles['PaginationLinks--isActive'] }),
						_react2['default'].createElement(_reactPagify2['default'].Segment, { field: 'nextPages' }),
						_react2['default'].createElement(_reactPagify2['default'].Ellipsis, { className: styles.PaginationEllipsis, previousField: 'nextPages', nextField: 'endPages' }),
						_react2['default'].createElement(_reactPagify2['default'].Segment, { field: 'endPages' }),
						_react2['default'].createElement(
							_reactPagify2['default'].Button,
							{ className: styles['PaginationLinks--next'], page: results.page + 1 },
							'»'
						)
					)
				)
			)
		);
	};

	_createClass(Search, null, [{
		key: 'propTypes',
		value: {
			loading: _react.PropTypes.bool,
			location: _react.PropTypes.object,
			params: _react.PropTypes.object,
			results: _react.PropTypes.oneOfType([_react2['default'].PropTypes.array, _react2['default'].PropTypes.object]),
			resultsError: _react.PropTypes.string,
			resultsLoading: _react.PropTypes.bool,
			routeParams: _react.PropTypes.object
		},
		enumerable: true
	}, {
		key: 'contextTypes',
		value: {
			store: _react.PropTypes.object.isRequired
		},
		enumerable: true
	}]);

	var _Search = Search;
	Search = _reactRedux.connect(function (state) {
		return {
			loading: state.search.loading,
			results: state.search.data,
			resultsError: state.search.error,
			resultsLoading: state.search.loading
		};
	})(Search) || Search;
	Search = _helpersConnectData2['default'](null, fetchDataDeferred)(Search) || Search;
	return Search;
})(_react.Component);

exports['default'] = Search;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Search/Search.js
 ** module id = 708
 ** module chunks = 0
 **/